import App from "../../app/App";
import Notifications from "../../app/Components/Notifications/Notifications";
import Forms from "../../app/Components/Forms/Forms";

const PasswordRecovery = {

    init() {

        this.el = $('[page="PasswordRecovery"]');

        if (!this.el.length) {
            return;
        }

        this.loading = this.el.find('.loading');
        this.form = this.el.find('form');
        this.inputs = this.form.find('input');

        Forms.init(this.form);
        Forms.focusFirstInput(this.form);

        this.bind();
    },

    bind() {
        $(document).on("submit", "form", function (e) {
            e.preventDefault();

            let thisForm = $(this);

            Forms.setFormSettings(Forms.getFormSettings(thisForm));
            Forms.setSendData(Forms.inputData(thisForm));
        });

        this.el.on("paste", function (e) {

            PasswordRecovery.form = PasswordRecovery.el.find('form');
            PasswordRecovery.inputs = PasswordRecovery.form.find('input');

            let clipBoardValues = PasswordRecovery.getClipboardContent(e);

            if (clipBoardValues.length == 5) {
                e.preventDefault();

                clipBoardValues.forEach((value, index) => {
                    if (value) {
                        if ($(PasswordRecovery.inputs[index]).length) {
                            $(PasswordRecovery.inputs[index]).val(value).trigger("keypress");
                        }
                    }
                });
            }
        });

        $(document).on("keyup keypress", this.inputs, function (e) {
            let previous = $(e.target).parents('[component="Input"]').prev();
            let next = $(e.target).parents('[component="Input"]').next();

            if (
                e.keyCode === 8 ||
                (e.type === "keypress" && e.keyCode === 9 && e.shiftKey === true && e.keyCode !== 9)
            ) {
                //  backspace
                previous.find('input').focus();
            }

            if (e.type === "keyup" && e.type !== "keypress") {

                if (
                    e.keyCode === 9 ||
                    e.keyCode === 8 ||
                    e.keyCode === 16 || (e.keyCode === 9 && e.shiftKey === true)
                ) {
                    return;
                }

                next.find('input').focus();
            }
        });
    },

    getClipboardContent(e) {
        let clp = (e.originalEvent || e).clipboardData;
        let text = null;

        if (clp === undefined || clp === null) {
            text = window.clipboardData.getData("text") || "";
        } else {
            text = clp.getData('text/plain') || "";
        }

        text = text.split("");

        return text;
    }
}
export default PasswordRecovery;